import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './DashboardLayout.scss';

function DashboardLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`dashboard-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <div className="main-content">
        <Header toggleSidebar={toggleSidebar} />
        <div className="content-wrapper">
          {children}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout; 